import { render, staticRenderFns } from "./ModalSendTest.vue?vue&type=template&id=6bbdbff0&scoped=true&"
import script from "./ModalSendTest.vue?vue&type=script&lang=js&"
export * from "./ModalSendTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbdbff0",
  null
  
)

export default component.exports